module.exports = __webpack_public_path__ + "media/קוף.9175bb2e.mp3";